
import { oz } from '@weft/utils';

export const CURRENCIES = Object.freeze({
  Usd: 'USD',
  Eur: 'EUR',
  Gbp: 'GBP',
  Ils: 'ILS',
});

export const CurrencySchema = oz.nativeEnum(CURRENCIES).openapi('Currency');

export type Currency = oz.infer<typeof CurrencySchema>;